
export const fetchSummaryByAppointment = async (apptId, userID, signal) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/summary/${apptId}?userID=${userID}`, {
    signal,
  });
  if (!response.ok) {
    throw new Error('Failed to fetch summary');
  }
  return response.json();
};